import React from 'react';
import SMSearchPagerView from 'components/search/SMSearchPagerView';
import SMCategorySearchFilterView from './SMCategorySearchFilterView';
import SMFeatureRoomView from 'components/features/SMFeatureRoomView';
import SMFeatureStaffView from 'components/features/SMFeatureStaffView';
import SMRestClient from 'lib/SMRestClient';
import sprintf from 'sprintf';

class SMCategoryFeatureListView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {
    return(
      <div className="site-main">
        <div className="page__even page__padding">
          <div className="container">
            <div className="row">
              <div className="col-sm-12 col-md-8">
                <div className="mod-review">
                  <h1 className="search-list__head-title">{this.props.title}</h1>
                  <span className="search-list__head-number">{this.props.totalCount}件</span>
                  <p className="search-list__head-description clear">{this.props.description}</p>
                  <div className="row">
                  {(()=>{
                    return this.props.features.map((feature, index) => {
                      return(
                        <div key={feature.id} className="col-sm-12 col-md-4 matome-box">
                          <a href={Routes.feature_path(feature.uid)}>
                            <div className="matome-linkbox">
                              <img src={feature.image} alt={sprintf("%s", feature.title)} className="is-hover" />
                              <h2 className="matome-subtitle">{feature.title}</h2>
                            </div>
                          </a>
                          <p className="js-line-camp-2 matome-description">{feature.description}</p>
                        </div>
                      );
                    });
                  })()}
                  </div>                
                </div>                
                <SMSearchPagerView 
                  delegate={this}
                  perPage={this.props.perPage}
                  totalCount={this.props.totalCount}
                  currentPage={this.props.currentPage}
                  options={{className: "details__main-nav"}}
                  links={SMRestClient.parseLinkString(this.props.linkString)} />
              </div>
              <div className="col-sm-12 col-md-4 sm-hide">
                <SMCategorySearchFilterView
                  keyword={this.props.keyword}
                  location={this.props.location}
                  geocode={this.props.geocode}
                  eventType={this.props.eventType}
                  capacity={this.props.capacity}
                  amenities={this.props.amenities}
                  minPrice={this.props.minPrice}
                  maxPrice={this.props.maxPrice}
                  spaceType={this.props.spaceType}
                  eventTypeList={this.props.eventTypeList}
                  capacityList={this.props.capacityList}
                  amenityList={this.props.amenityList} 
                  spaceTypeList={this.props.spaceTypeList}
                />
                <SMFeatureRoomView roomFeatures={this.props.roomFeatures} />
                <SMFeatureStaffView staffFeatures={this.props.staffFeatures} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMCategoryFeatureListView;




// WEBPACK FOOTER //
// ./app/javascript/components/categories/SMCategoryFeatureListView.jsx